import { useSyncExternalStore } from 'react';

export const BREAKPOINTS = {
  aboveMobile: '(min-width: 431px)',
  desktop: '(min-width: 1024px)',
} as const;

const subscribe = (query: string) => (onStoreChange: () => void) => {
  if (typeof window === 'undefined') return () => {};

  const mql = window.matchMedia(query);
  const handler = () => onStoreChange();
  mql.addEventListener('change', handler);
  return () => mql.removeEventListener('change', handler);
};

const getSnapshot = (query: string) => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(query).matches;
};

export function useMediaQuery(query: string = BREAKPOINTS.aboveMobile): boolean {
  return useSyncExternalStore(subscribe(query), () => getSnapshot(query), () => false);
}

export const useIsAboveMobile = () => useMediaQuery(BREAKPOINTS.aboveMobile);
export const useIsDesktop = () => useMediaQuery(BREAKPOINTS.desktop);
